<!-- Loading -->
<div *ngIf="isActive" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>
